<div class="slider mb-3">
  <!-- @for (img of item; track $index; let i = $index) {
    <a href="#slide-1">{{i}}</a>
    } -->

  <div class="slides">
    @for (img of item; track $index; let i = $index) {
      <div id="slide-1">
        <img [src]="img.src" [alt]="img.alt" (click)="opemViewImg(img.src)" />
      </div>
    }
  </div>
</div>
